import { forgotPasswordURL, getDashboardURL, loginURL, logoutURL, recoverPasswordURL, resendOTPURL, setPasswordURL, selectRoleURL } from '@app/constants/ApiEndPoints';
import {removeWindowClass} from '@app/utils/helpers';
import axios from 'axios';

export const loginByAuth = async (payload) => {
	try {
		const response = await axios.post(loginURL, payload);
		if (response.status === 200 /* && response.statusText === "OK"*/) {
			if (response.data.status === 200 && response.data.token) {
				localStorage.setItem('token', response.data.token);
				removeWindowClass('login-page');
				removeWindowClass('hold-transition');
			}
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const forgotPassword = async (payload) => {
	try {
		const response = await axios.post(forgotPasswordURL, payload);
		if (response.status === 201 /* && response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const recoverPassword = async (payload) => {
	try {
		const response = await axios.post(recoverPasswordURL, payload);
		if (response.status === 201 /* && response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const resendOTP = async (payload) => {
	try {
		const response = await axios.post(resendOTPURL, payload);
		if (response.status === 201 /* && response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const setPassword = async (payload) => {
	try {
		const response = await axios.post(setPasswordURL, payload);
		if (response.status === 200 /* && response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getDashboard = async () => {
	try {
		const response = await axios.get(getDashboardURL);
		if (response.status === 200 /* && response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

// Social authentication methods removed - not implemented
// If needed in the future, implement proper OAuth flows

export const logOutUser = async () => {
	try {
		const response = await axios.get(logoutURL);
		if (response.status === 200 /* && response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const selectRole = async (role_id: number) => {
	try {
		const response = await axios.post(selectRoleURL, { role_id });
		if (response.status === 200 || response.status === 201) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};
